const getUserData = () => {
    try {
      const data = localStorage.getItem("userDetails");
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error parsing userData from localStorage", error);
      return null;
    }
  };
  export const  clearUserData = () =>{
    localStorage.removeItem("userDetails");
    window.location.reload();
  }
  export const getUserID = () => getUserData()?.uid;
  export const userID = getUserData()?.uid;
  export const userName = getUserData()?.name
  export const userRole = getUserData()?.role;
  export const userEmail = getUserData()?.email;
  export const userPhone = getUserData()?.phoneNumber;
  export const userStatus = getUserData()?.status;